import * as WORKFLOW_API from '@/api/workflow'

export default {
  state: {
    transitions: {},
    modelUserTransitions: {},
    histories: {},
    ding: 0
  },
  getters: {
    getWorkflowTransitions: state => workflowName => state.transitions[workflowName],
    getWorkflowModelUserTransitions: state => workflowName => state.modelUserTransitions[workflowName],
    getWorkflowStatesHistories: state => state => workflowName => state.histories[workflowName]
  },
  mutations: {
    setTransitions (state, { workflowName, data }) {
      state.transitions[workflowName] = data
    },
    setModelStatesHistories (state, { workflowName, histoires }) {
      state.histories[workflowName] = histories
    },
    setModelUserTransitions (state, { workflowName, data }) {
      state.modelUserTransitions[workflowName] = data
    },
    updateModelUserTransition (state, { workflowName, transition }) {
      state.modelUserTransitions[workflowName].map(o => o.id === transition.id ? transition : false || o)
    },
    removeModelUserTransition (state, { workflowName, id }) {
      state.modelUserTransitions[workflowName].filter(o => o.id !== id)
    },
    instanceApproval(state) {
      state.modelUserTransitions[workflowName] = data
    }
  },
  actions: {
    loadWorkflowTransitions ({ commit }, workflowName) {
      return WORKFLOW_API.getWorkflowTransitions(workflowName).then(resp => {
        commit('setTransitions', { workflowName: workflowName, data: resp.data })
        return resp
      })
    },
    loadWorkflowModelStatesHistories ({ commit }, { workflowName, model }) {
      return WORKFLOW_API.getWorkflowStatesHistories(workflowName, model).then(resp => {
        commit('setModelStatesHistories', { workflowName: workflowName, histories: resp.data })
        return resp
      })
    },
    loadWorkflowModelUserTransitions ({ commit }, { workflowName, modelType, modelId }) {
      return WORKFLOW_API.getWorkflowUserTransitions(workflowName, modelType, modelId).then(resp => {
        commit('setModelUserTransitions', {
          workflowName: workflowName,
          data: resp.data
        })
        return resp
      })
    },
    createWorkflowUserTransitions ({ commit }, { workflowName, modelType, modelId, transitions }) {
      return WORKFLOW_API.createWorkflowUserTransitions(workflowName, modelType, modelId, transitions).then(resp => {
        commit('setModelUserTransitions', {
          workflowName: workflowName,
          data: resp.data
        })
        return resp
      })
    },
    createWorkflowUserTransition ({ commit }, { workflowName, modelType, modelId, data }) {
      return WORKFLOW_API.createWorkflowUserTransition(workflowName, modelType, modelId, data)
    },
    updateWorkflowUserTransition ({ commit }, { workflowName, id, transition }) {
      return WORKFLOW_API.updateWorkflowUserTransition(workflowName, id, transition).then(resp => {
        commit('updateModelUserTransition', {
          workflowName: workflowName, transition: transition
        })
        return resp
      })
    },
    deleteFromWorkflowUserTransitions ({ commit }, { workflowName, id }) {
      return WORKFLOW_API.removeWorkflowUserTransition(workflowName, id)
    },
    applyWorkflowUserTransition ({ commit }, { workflowName, transitionData }) {
      return WORKFLOW_API.applyWorkflowUserTransition(workflowName, transitionData)
    },
    processDingtalkRequest ({ commit }, { workflowModelType, workflowModelId, approvalName }) {
      return WORKFLOW_API.processDingtalkRequest(workflowModelType, workflowModelId, approvalName)
    },
    autoSendDingtalkApprovalRequest ({ commit }, { workflowTransitionId, approvalName }) {
      return WORKFLOW_API.autoSendDingtalkApprovalRequest(workflowTransitionId, approvalName)
    },
    getDingtalkLastRemindDates ({ commit }, { workflowModelType, workflowModelId }) {
      return WORKFLOW_API.getDingtalkLastRemindDates(workflowModelType, workflowModelId)
    }
  }
}
